import { Pipe, PipeTransform } from '@angular/core';
import { ITravellerObject } from "libraries/service/resources/hotel/ISearchParameters";

@Pipe({
    name: 'getTravellers'
})

export class GetTravellersPipe implements PipeTransform {
    public transform(travellers: object): ITravellerObject[] {
        return Object.keys(travellers)
            .map((key: string) => ({
                ...travellers[key],
                title: travellers[key].title ? travellers[key].title : 'Mr',
                type: travellers[key].type ? travellers[key].type : 'Adult',
            }));
    }
}
